import { restGet, restPut } from "apiCommandsExecutor/rest";

import { LegalDataDto, OrganizationBranchDto } from "./restModels";
import { UpdateLegalDataRequestDto } from "./restRequests";

// ===== Заведение: тариф и реквизиты (REST /api/rest/warehouse/v1) =====
// Заведение бэк берёт из аккаунта — идентификатор в запросах не передаём.

export const getOrganizationBranch = () => restGet<OrganizationBranchDto>("/organization-branch");

// Сохраняются только редактируемые поля карточки, остальные бэк переносит из текущей.
export const updateLegalData = (body: UpdateLegalDataRequestDto) =>
    restPut<LegalDataDto>("/organization-branch/legal-data", body);
